import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { UtilService } from '../../shared/services';

@Component({
  selector: 'app-fundraiser-slider-img',
  templateUrl: './fundraiser-slider-img.component.html',
  styleUrls: ['./fundraiser-slider-img.component.scss']
})
export class FundraiserSliderImgComponent implements OnInit {

  @Input() gallery;
  @Input() isFOS;
  @Input() hasThumbs;
  @Input() slideType;
  @Input() basicInfo;
  @Input() shadow;
  @Input() share = true;
  @Input() isPreview = false;
  isMobile;
  currentIndex = 0;
  focus = 0;
  autoSlide;

  constructor(
    public util: UtilService,
    public domSanitizer: DomSanitizer
  ) { }

  ngOnInit(): void {
    this.isMobile = this.util.isMobile();
    this.autoSlide = this.gallery?.length > 1 ? true : false;
    if (this.util.isBrowser) {
      setTimeout(() => {
        const arrows = document.getElementsByClassName('glide__arrow');
        for (let i=0; i< arrows.length; i++) {
          arrows[i].addEventListener('click', () => {
            this.autoSlide = false;
          });
        }
      }, 1000);
    }
  }

  ngOnChanges(change) {
    if (!change.gallery.currentValue && this.isPreview || change?.gallery?.currentValue?.length === 0 && this.isPreview) {
      // dafault image object
      this.gallery = [ {
          id: 1,
          media_type: "image",
          detail_1: null,
          detail_2: null,
          detail_3: null,
          display_type_1: "leaderboard",
          status: 1,
          cdn_path: "https://d1odpswjdg60uv.cloudfront.net/images/fundraiser-default-image.jpg"
        }
      ]
    }
  }

  addYoutubeEmbed(slide) {
    const id = this.util.getYouTubeId(slide.path);
    slide.videoSrc = this.domSanitizer.bypassSecurityTrustResourceUrl('https://www.youtube.com/embed/' + id + '?autoplay=1&rel=0');
    slide.showVideo = true;
    this.autoSlide = false;
  }

  thumbsOnClick(i) {
    this.autoSlide = false;
    this.focus = i;
    this.currentIndex = i;
  }

  getIndex(e) {
    if (e.direction === '>') {
      this.currentIndex++;
    } else if (e.direction === '<') {
      this.currentIndex--;
    }
    if (this.currentIndex >= this.gallery?.length) {
      this.currentIndex = 0;
    } else if (this.currentIndex < 0) {
      this.currentIndex = this.gallery?.length - 1;
    }
  }

}
